import ByArticleCreateView from "../../backyard/view/article/Create.vue";
import ByArticleListView from "../../backyard/view/article/List.vue";
import ByArticleDetailView from "../../backyard/view/article/Detail.vue";


let lbArticleRouter = [];

let byArticleRouter = [
		{
			path: 'article/list',
			name: "byArticleList",
			component: ByArticleListView,
			meta: {
				requiresAuth: true,
				breadcrumbs: [
					{
						name: "byArticleList",
						title: "文章列表"
					}
				]
			}
		},
		{
			path: 'article/list/:type',
			name: "byArticleNewsList",
			component: ByArticleListView,
			meta: {
				requiresAuth: true,
				breadcrumbs: [
					{
						name: "byArticleNewsList",
						title: "新闻列表"
					}
				]
			}
		},
		{
			path: 'article/create',
			name: "byArticleCreate",
			component: ByArticleCreateView,
			meta: {
				requiresAuth: true,
				breadcrumbs: [
					{
						name: "byArticleList",
						title: "文章列表"
					},
					{
						name: "byArticleCreate",
						title: "创建文章"
					}
				]
			}
		},
		{
			path: 'article/edit/:id',
			name: "byArticleEdit",
			component: ByArticleCreateView,
			meta: {
				requiresAuth: true,
				breadcrumbs: [
					{
						name: "byArticleList",
						title: "文章列表"
					},
					{
						name: "byArticleEdit",
						title: "编辑文章"
					}
				]
			}
		},
		{

			path: 'article/detail/:id',
			name: "byArticleDetail",
			component: ByArticleDetailView,
			meta: {
				requiresAuth: true,
				breadcrumbs: [
					{
						name: "byArticleList",
						title: "文章列表"
					},
					{
						name: "byArticleDetail",
						title: "文章详情"
					}
				]
			}
		}
	]
	;


export {lbArticleRouter, byArticleRouter}





// WEBPACK FOOTER //
// ./src/common/router/ArticleRouter.js